require("angular");

var app = angular.module("election-guide", [require("angular-ui-router/release/angular-ui-router.min")]);

module.exports = app;
